const TARGET_SAMPLE_RATE = 16000;

function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}

/** Encode a mono AudioBuffer as a 16-bit PCM WAV Blob. */
function encodeWav(audioBuffer) {
    const channelData = audioBuffer.getChannelData(0);
    const buffer = new ArrayBuffer(44 + channelData.length * 2);
    const view = new DataView(buffer);

    writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + channelData.length * 2, true);
    writeString(view, 8, "WAVE");
    writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, audioBuffer.sampleRate, true);
    view.setUint32(28, audioBuffer.sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeString(view, 36, "data");
    view.setUint32(40, channelData.length * 2, true);

    let offset = 44;
    for (let i = 0; i < channelData.length; i++) {
        const sample = Math.max(-1, Math.min(1, channelData[i]));
        view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
        offset += 2;
    }

    return new Blob([buffer], { type: "audio/wav" });
}

/** Decode recorded audio and resample to 16 kHz mono WAV for Azure Speech. */
async function convertToWav(blob) {
    const arrayBuffer = await blob.arrayBuffer();
    const decodeContext = new AudioContext();
    const decoded = await decodeContext.decodeAudioData(arrayBuffer);
    await decodeContext.close();

    const frameCount = Math.ceil(decoded.duration * TARGET_SAMPLE_RATE);
    const offlineContext = new OfflineAudioContext(1, frameCount, TARGET_SAMPLE_RATE);
    const source = offlineContext.createBufferSource();
    source.buffer = decoded;
    source.connect(offlineContext.destination);
    source.start(0);

    const rendered = await offlineContext.startRendering();
    return encodeWav(rendered);
}

/** Request mic access and start a MediaRecorder session. */
export async function startRecording() {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    const chunks = [];

    mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
            chunks.push(event.data);
        }
    };

    mediaRecorder.start();

    return {
        mediaRecorder,
        stream,
        chunks,
    };
}

/** Stop an active recording and return the captured audio as a 16 kHz mono WAV Blob. */
export function stopRecording(handle) {
    return new Promise((resolve, reject) => {
        handle.mediaRecorder.onstop = async () => {
            handle.stream.getTracks().forEach((track) => track.stop());
            try {
                const webmBlob = new Blob(handle.chunks, { type: "audio/webm" });
                const wavBlob = await convertToWav(webmBlob);
                resolve(wavBlob);
            } catch (err) {
                reject(err);
            }
        };
        handle.mediaRecorder.stop();
    });
}
